"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWidgetSuggestedActions = void 0;
var react_1 = require("react");
var WidgetContext_1 = require("./WidgetContext");
var useWidgetSuggestedActions = function () {
    var context = (0, react_1.useContext)(WidgetContext_1.WidgetContext);
    if (context === null) {
        throw new Error("useWidgetSuggestedActions must be used within a WidgetProvider");
    }
    return {
        set: function (suggestedActions) {
            context.widget.setSuggestedActions(suggestedActions);
        },
        update: function (suggestedActions) {
            context.widget.updateSuggestedActions(suggestedActions);
        },
        remove: function (suggestedActions) {
            context.widget.removeSuggestedActions(suggestedActions);
        },
        removeAll: function () {
            context.widget.removeAllSuggestedActions();
        }
    };
};
exports.useWidgetSuggestedActions = useWidgetSuggestedActions;
